/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var FacebookMessengerIcon = createIcon({
  name: 'FacebookMessengerIcon',
  height: 512,
  width: 448,
  svgPath: 'M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default FacebookMessengerIcon;